import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appReducer from '../../store/app/appSlice';
import chargingReducer from '../../store/charging/chargingSlice';
import configReducer from '../../store/config/configSlice';
import dataReducer from '../../store/data/dataSlice';
import { facadeApiV2 } from '../../store/facade/facadeApiV2';
import { facadeApiV3 } from '../../store/facade/facadeApiV3';
import langReducer from '../../store/lang/langSlice';
import loginReducer from '../../store/login/loginSlice';
import { rtkQueryLogger } from '../../store/middleware/rtkQueryLogger';
import routeReducer from '../../store/route/routeSlice';
import searchReducer from '../../store/search/searchSlice';
import tokenReducer from '../../store/tokenHandling/tokenHandlingSlice';
import tourReducer from '../../store/tour/tourSlice';
import vehicleProfileReducer from '../../store/vehicleProfile/vehicleProfileSlice';
import widgetReducer from '../../store/widget/widgetSlice';
import { config } from '../config';

const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenReducer,
    charging: chargingReducer,
    data: dataReducer,
    route: routeReducer,
    tour: tourReducer,
    search: searchReducer,
    vehicleProfile: vehicleProfileReducer,
    widget: widgetReducer,

    [facadeApiV2.reducerPath]: facadeApiV2.reducer,
    [facadeApiV3.reducerPath]: facadeApiV3.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware().concat(facadeApiV2.middleware).concat(facadeApiV3.middleware).concat(rtkQueryLogger),
        devTools: config.serviceEnvironment !== 'production',
    });
};
export const store = setupStore();

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type RootDispatch = typeof store.dispatch;
export type RootStore = typeof store;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
